module.exports = __webpack_public_path__ + "static/media/linkIcon.33aa8abd.svg";